import { useEffect, useMemo, useState } from 'react';

import { AccessibilityScoreData } from '../components/accessibility-trends-chart/types';

// 🔴 MOCK: Replace with real API
// Mock hook to simulate data fetching with realistic loading state
export const useAccessibilityTrendsQuery = (): {
	data: AccessibilityScoreData[] | null;
	isLoading: boolean;
	error: null;
} => {
	const [isLoading, setIsLoading] = useState(true);
	const [data, setData] = useState<AccessibilityScoreData[] | null>(null);

	const mockData = useMemo(() => {
		const generatedData: AccessibilityScoreData[] = [];
		const now = new Date();

		// Generate data for the last 30 days
		for (let i = 29; i >= 0; i--) {
			const date = new Date(now);
			date.setDate(now.getDate() - i);

			// Generate realistic accessibility scores between 70-95 with deterministic variation
			const baseScore = 82;
			const seed = i * 7; // Use day index as seed for consistent but varied data
			const variation = Math.sin(seed) * 8 + Math.cos(seed * 1.5) * 4;
			const score = Math.max(70, Math.min(95, Math.round(baseScore + variation)));

			generatedData.push({
				date: date.toISOString().split('T')[0],
				score
			});
		}

		return generatedData;
	}, []);

	useEffect(() => {
		// Simulate API call with realistic loading time
		const loadingTimer = setTimeout(() => {
			setData(mockData);
			setIsLoading(false);
		}, 1500); // 1.5 seconds loading time

		return () => clearTimeout(loadingTimer);
	}, [mockData]);

	return {
		data,
		isLoading,
		error: null
	};
};
